// 为了减少打包体积， 在使用高版本语法时，需要单独引入core-js下对应的包，按需引用
import 'react-app-polyfill/ie11';
import 'core-js/features/array/includes';
import 'core-js/features/array/find';
import 'core-js/features/array/find-index';
import 'core-js/features/array/fill';
import 'core-js/features/string/includes';
import 'core-js/features/string/starts-with';
import 'core-js/features/string/ends-with';
import 'core-js/features/string/repeat';
import 'core-js/features/object/is';
import 'core-js/features/object/entries';
import 'core-js/features/object/set-prototype-of';
import 'core-js/features/weak-set';
import 'core-js/features/weak-map';
import 'core-js/features/symbol';
import { createGlobalStyle } from 'styled-components';
import React from 'react';
import ReactDOM from 'react-dom';
import injectWebId, { setWebidCookie } from './utils/fingerprint';
import configureStore from './models/configure_store';
import { Provider } from 'react-redux';
import Captcha from './components/captcha';
import * as logger from './utils/logger';
import { getInternationalData, getFeedbackData } from './service/captcha';
import { Context, zh, en, ja, zhHant } from './i18n';
import { ThemeProvider } from 'styled-components';
import getTheme from './theme/default';
import { SERVER_MAP, SERVER_URL, isNative, searchObj, isMobile, envRegion } from './utils/constants';
import { debug } from './utils/debug';
import { handlerTcpIpReport } from './utils/tcpIpReport';
import ErrorBoundary from 'react-error-boundary';
import ErrorPage from './components/error';
import customFont from './customfont';
import { fetchSettings } from './service/jsbridge';
import { setOptions, getTeaCommonParams, detectCaptchaOptions, detectSecondVerifyWebOptions, errorStack, getRootElem, pageSlideHandler, isObject, getFp } from './utils/utils';
import axios from 'axios';
import * as slardar from './utils/lib/slardar';
import { secondVerifyWebShow } from './utils/lib/secondVerifyWeb';
import { setBaseFontSize } from '@/utils/rem';
import singleText from './utils/single-text';

import SMS from './sms';
import VerifyCenter from './verifycenter';
import { TikTokTextFont } from './components/font/TikTokTextFont';
// debug 用, 只有在 boe 和 开发环境起作用
import '@/utils/lib/vconsole';
import './utils/jsvmp-utils';
import { saveCallBack } from './utils/callBack';
import { antiDebug } from './utils/antiDebug';
require('core-js/features/map');
require('core-js/features/set');
require('raf').polyfill(window);

antiDebug();

if (!Date.now) {
  Date.now = function () {
    return new Date().getTime();
  };
}
const NativeGlobalStyle = createGlobalStyle`
  html, body {
    padding: 0;
    margin: 0;
    width:100%;
    height:100%;
  }
`;
const GlobalStyle = createGlobalStyle`
body.captcha-disable-scroll {
  overflow: hidden;
}
#__vconsole .vc-mask {
  z-index: 9999999999 !important;
}
#__vconsole .vc-panel {
  z-index: 99999999999 !important;
}
.captcha_verify_container {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -webkit-touch-callout: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}
.captcha_verify_container img {
  pointer-events: auto;
  background: transparent;
}
`;
function getFailLang(lang: string) {
  if (/zh-hant/i.test(lang)) {
    return zhHant;
  }
  if (lang.startsWith('zh')) {
    return zh;
  }
  if (lang === 'ja') {
    return ja;
  }
  return en;
}
type CaptchaContainerProps = {
  options: any;
  lang: string;
  resize: () => void;
};
class CaptchaContainer extends React.Component<
  CaptchaContainerProps,
  {
    text: any;
  }
> {
  constructor(props: CaptchaContainerProps) {
    super(props);
    const failText = getFailLang(props.lang);
    // 兜底策略
    this.state = {
      text: {
        ...failText,
        // net_error: failText.net_error,
      },
    };
  }
  componentDidMount = async () => {
    const text = await singleText.getText(this.props.lang);
    this.setState({
      text,
    });
  };

  render() {
    const { options, resize } = this.props;
    const { theme } = options;
    return (
      <>
        {isNative && <NativeGlobalStyle />}
        <GlobalStyle />
        <ErrorBoundary
          FallbackComponent={ErrorPage}
          onError={async (error: Error) => {
            errorStack.push({
              action: 'syntaxError',
              msg: error.stack,
              time: Date.now(),
            });
            debug(error);
          }}
        >
          <Context.Provider value={this.state.text}>
            <ThemeProvider theme={theme}>
              <Captcha {...options} resize={resize} />
            </ThemeProvider>
          </Context.Provider>
        </ErrorBoundary>
      </>
    );
  }
}
export const getCaptchaWebId = injectWebId;

async function initCaptcha(captchaOptions: any = {}) {
  // 检测必填参数
  detectCaptchaOptions(captchaOptions);
  // 如果options传了host以host为主，如果没有从SERVER_URL取
  let baseURL = SERVER_URL;
  // 决策出码方式有两种：一种是通过challenge_code决策出码 一种是通过决策透传形式
  // verify_data为决策透传方式，如果采用了决策透传的方案，baseURL也会受verify_data的region控制
  if (captchaOptions.verify_data) {
    // verify_data业务方传过来的可能是json字符串也可能是对象，所以做try catch处理
    try {
      const verify_data: {
        region: keyof typeof SERVER_MAP;
        log_id: string;
      } = typeof captchaOptions.verify_data === 'string' ? JSON.parse(captchaOptions.verify_data) : captchaOptions.verify_data;
      if (verify_data.region && SERVER_MAP[verify_data.region]) {
        captchaOptions.region = verify_data.region;
        baseURL = SERVER_MAP[verify_data.region];
      }
      if (verify_data.log_id) {
        window.logIdMap.shark_log_id = verify_data.log_id;
      }
      captchaOptions.verify_data = verify_data;
    } catch (err) {}
  }
  axios.defaults.baseURL = captchaOptions.mainHost || captchaOptions.host || baseURL;
  // 对options做预处理
  setOptions(captchaOptions);
  // 整理验证码自定义样式的配置
  if (isNative) {
    const settings = await fetchSettings(captchaOptions);
    captchaOptions.theme = getTheme(settings.theme || captchaOptions.theme || {});
  } else {
    // 外传主题参数和默认主题合并
    captchaOptions.theme = getTheme(captchaOptions.theme || captchaOptions);
  }
  // 获取tea的通参
  const teaParams = getTeaCommonParams(captchaOptions);

  window.captchaOptions = captchaOptions;
  // 在 initVerifyOptions 方法中进行和该处重复的操作，这里是为了兼容没有 initVerifyOptions 方法的版本。
  if (!isNative && captchaOptions.fpCookieOption) {
    window.fpCookieOption = captchaOptions.fpCookieOption;
  }
  // 种设备指纹 如果是决策透传形式，需要使用服务端verify_data返回的fp覆盖本地生成的fp
  // 服务端 fp 获取逻辑：先从业务请求query串拿verifyFp-->没有再从header头 X-Vc-Fp拿-->没有再从cookie里面的s_v_web_id拿-->再没有从cookie的s_v_web_id_secure拿-->还拿不到就生成一个
  try {
    await injectWebId(captchaOptions.verify_data ? captchaOptions.verify_data.fp || captchaOptions.verify_data.Fp : '');
  } catch (err) {}

  // 初始化Tea
  logger.init(teaParams);
  // 初始化slardar日志上报
  await slardar.init(captchaOptions);
  await slardar.start();
  logger.trackEvent('init', {
    stage: 'excuteRenderCaptchaFunction',
    verify_data: captchaOptions?.verify_data,
  });

  // 初始化store redux
  const store = configureStore();
  // challenge_code出码形式 如果verify_data和challenge_code都存在，按照verify_data方式出码
  const captchaData: Partial<Record<'challenge_code' | 'type', string>> = {
    challenge_code: captchaOptions.challenge_code || 3058,
  };
  // 如果是决策透传形式，按照subtype设置type值类型
  if (captchaOptions.verify_data && captchaOptions.verify_data.subtype) {
    captchaData.type = captchaOptions.verify_data.subtype;
  }
  store.dispatch.captcha.update(captchaData);
  return store;
}
let allOptions: any = {};
/**
 * 传入各种验证形式需要的参数，方便后续的调用
 * @param allOptions
 * {
 *    commonOptions: {
 *      aid:
 *      iid:
 *      did:
 *    },
 *    captchaOptions: {},
 *    secondVerifyWebOptions: {},
 *    secondVerifyH5Options: {},
 * }
 */
export const initVerifyOptions = function (options: any = {}) {
  console.log('oec capture load');
  allOptions = options;
  window.verifyOptions = options;
  const captchaOptions = options.captchaOptions;
  // 默认加载 sdk 就会生成 fp （此时拿不到 fpCookieOption）,这里会在有 fpCookieOption 的情况下重新设置一次 cookie
  if (!isNative && captchaOptions?.fpCookieOption) {
    window.fpCookieOption = captchaOptions.fpCookieOption;
    try {
      // 对序列化进行try-catch
      if (JSON.stringify(captchaOptions.fpCookieOption) !== '{}') {
        setWebidCookie(getFp());
      }
    } catch (err) {}
  }
  if (!process.env.IS_ABROAD) {
    if (!isMobile && allOptions?.commonOptions?.aid === 4272) {
      // 初始化slardar日志上报
      // tcpid目前有问题，先下掉
      // slardar.init({
      //   ...allOptions?.commonOptions,
      //   ...allOptions?.captchaOptions,
      // });
      // slardar.start();
      // handlerTcpIpReport();
    }
  }
};

/**
 * 渲染验证码，执行过 init 方法后，调用此方法只需要传入 decision， renderCaptcha({verify_data: "{xxx:xxx}"})
 * @param optionsOrDecision
 * optionsOrDecision 可能是 options 也可能传的是 decision
 * options 参数是为了兼容历史版本 2.16.0 之前的版本， 之前版本决策信息会一起放在 options 中，每次调用都需要传入所有的参数;
 * decision  中 challenge_code 和 verify_data 只需要有一个
 * {
 *    challenge_code: 3058,
 *    verify_data: {}
 * }
 */
export const renderCaptcha = async function renderCaptcha(optionsOrDecision: Obj) {
  // errorStack用来记录操作过程中的错误，并最终通过tea上报，这里做个清空
  errorStack.empty();
  let options = optionsOrDecision; // 这里兼容没有 init 过的，之前直接调用 renderCaptcha 的方式

  if (!optionsOrDecision.aid) {
    // 传入决策表示是使用 init 传过参数的新调用方式
    const { commonOptions = {}, captchaOptions = {}, ...rest } = allOptions;

    options = {
      ...rest,
      ...commonOptions,
      ...captchaOptions,
      ...optionsOrDecision.commonOptions,
      ...optionsOrDecision.captchaOptions,
      ...optionsOrDecision,
    };
  }
  saveCallBack(options);
  const store = await initCaptcha(options);

  // 获取挂载元素
  let rootElem = getRootElem(options);
  const resize = setBaseFontSize(rootElem, options.viewport, options.baseEM);
  ReactDOM.render(
    <Provider store={store}>
      <TikTokTextFont />
      <CaptchaContainer options={options} lang={options.lang || (envRegion === 'cn' ? 'zh' : 'en')} resize={resize} />
    </Provider>,
    rootElem
  );
};

export default renderCaptcha;

export const closeCaptcha = function () {
  pageSlideHandler.allow();
  const rootElem = document.getElementById(window.captchaOptions.ele);
  if (rootElem) {
    document.body.classList.remove('captcha-disable-scroll');
    ReactDOM.unmountComponentAtNode(rootElem);
    rootElem.style.display = 'none';
  } else {
    throw new Error('请传入正确的挂载元素');
  }
};
/**
 * 会根据决策透传的信息来自动判断出什么验证码或者二次验证
 * @param verify_data 决策透传的信息
 */
export const autoRender = function (renderOptions: { verify_data: String | Obj; commonOptions?: Obj; captchaOptions?: Obj; secondVerifyH5Options?: Obj; secondVerifyWebOptions?: Obj }) {
  if (renderOptions.verify_data) {
    // verify_data业务方传过来的可能是json字符串也可能是对象，所以做try catch处理
    try {
      const _verify_data = typeof renderOptions.verify_data === 'string' ? JSON.parse(renderOptions.verify_data) : renderOptions.verify_data;
      if (_verify_data.code == 10000) {
        // 验证码
        renderCaptcha({
          ...renderOptions,
          verify_data: renderOptions.verify_data,
        });
      } else if (_verify_data.code == 20000) {
        // 二次验证
        renderSecondVerifyWeb({
          commonOptions: renderOptions.commonOptions,
          secondVerifyWebOptions: renderOptions.secondVerifyWebOptions,
          verify_data: renderOptions.verify_data,
        });
      }
    } catch (err) {
      console.error('The parameter verify_data is required'); // eslint-disable-line
      throw new Error('The parameter verify_data is required');
    }
  }
};
/**
 * 唤起 web 版二次验证
 * @param verify_data 决策透传方式的透传信息，直接传就行
 * @param decision 透传风控返回的shark_event 或 code 码 用来控制出什么类型的验证
 * @param account 非决策透传是需要传 account （会覆盖 init 传入的 account）
 */
export const renderSecondVerifyWeb = async function (renderOptions: {
  commonOptions?: Obj;
  verify_data?: String | Obj;
  decision?: String | Number; // 非决策透传
  account?: String | Number; // 非决策透传需要传
  secondVerifyWebOptions?: Obj; // 合并覆盖 init 参数， 非决策透传，且非登录态 secondVerifyWebOptions.commonParams.verify_ticket 必须传
}) {
  let _account = renderOptions.account || '';
  let _decision = renderOptions.decision || 'mobile_sms_verify';
  let _verify_ticket = renderOptions?.secondVerifyWebOptions?.commonParams?.verify_ticket || '';
  const _commonParams = {
    ...allOptions?.secondVerifyWebOptions?.commonParams,
    ...renderOptions?.secondVerifyWebOptions?.commonParams,
    verify_ticket: _verify_ticket,
  };
  const otherOptions: Obj = {};
  if (renderOptions.verify_data) {
    // verify_data业务方传过来的可能是json字符串也可能是对象，所以做try catch处理
    try {
      const _verify_data = typeof renderOptions.verify_data === 'string' ? JSON.parse(renderOptions.verify_data) : renderOptions.verify_data;
      if (_verify_data.subtype) {
        _decision = _verify_data.subtype;
        if (_verify_data.subtype === 'mobile_sms_verify' || _verify_data.subtype === 'mobile_up_sms_verify' || _verify_data.subtype === 'mobile_voice_sms_verify') {
          _account = _verify_data.mobile;
        } else if (_verify_data.subtype === 'email_verify') {
          _account = _verify_data.email;
        }
        if (_verify_data.verify_ticket) {
          _commonParams.verify_ticket = _verify_data.verify_ticket;
        }
        if (_verify_data.subtype === 'face_verify') {
          _commonParams.sec_user_id = _verify_data.sec_user_id;
        }
        if (_verify_data.subtype === 'mobile_up_sms_verify') {
          otherOptions.channel_mobile = _verify_data.channel_mobile;
          otherOptions.sms_content = _verify_data.sms_content;
        }
      }
    } catch (err) {}
  }
  const options = {
    ...allOptions.commonOptions,
    ...allOptions.secondVerifyWebOptions,
    ...renderOptions.commonOptions,
    ...renderOptions.secondVerifyWebOptions,
    commonParams: _commonParams,
    ...otherOptions,
  };
  // 参数校验
  detectSecondVerifyWebOptions(options);
  const _options = {
    postPc: _decision,
    ...options,
  };
  _account && (_options.account = _account);
  await secondVerifyWebShow(_options);
};
/**
 * 唤起 h5 版二次验证
 * @param verify_data 决策透传的信息
 * @param decision 非决策透传方式：透传服务端返回的验证方式; 海外目前支持 邮箱 验证码 密码三种认证方式
 */
export const renderSecondVerifyH5 = function (renderOptions: {
  commonOptions?: Obj;
  verify_data?: String | Obj;
  decision?: String | Number; // 非决策透传
  secondVerifyH5Options?: Obj;
}) {
  let _decision = renderOptions.decision || 'mobile_sms_verify';
  let _verify_ticket = renderOptions?.secondVerifyH5Options?.commonParams?.verify_ticket || '';
  if (renderOptions.verify_data) {
    // verify_data业务方传过来的可能是json字符串也可能是对象，所以做try catch处理
    try {
      const _verify_data = typeof renderOptions.verify_data === 'string' ? JSON.parse(renderOptions.verify_data) : renderOptions.verify_data;
      if (_verify_data.subtype) {
        _decision = _verify_data.subtype;
      }
      if (_verify_data.verify_ticket) {
        _verify_ticket = _verify_data.verify_ticket;
      }
    } catch (err) {}
  }
  const options = {
    ...allOptions.commonOptions,
    ...allOptions.secondVerifyH5Options,
    ...renderOptions.commonOptions,
    ...renderOptions.secondVerifyH5Options,
    use_by_native_shell: 0,
    use_xhr: 1,
    decision_config: _decision,
    verify_ticket: _verify_ticket,
    verify_data: isObject(renderOptions.verify_data) ? JSON.stringify(renderOptions.verify_data) : renderOptions.verify_data,
  };
  let url = allOptions.secondVerifyH5Options.bHost || '/';
  if (url.charAt(url.length - 1) !== '/') {
    url += '/';
  }
  url += 'verifycenter/authentication/?';
  // 将 options 转为 url 字符串参数
  Object.keys(options).forEach((key) => {
    if (key === 'theme') {
      url += `${key}=${encodeURI(JSON.stringify(options[key]))}&`;
    } else if (typeof options[key] !== 'undefined') {
      url += `${key}=${encodeURI(options[key])}&`;
    }
  });
  url = url.slice(0, -1);
  window.location.href = url;
};

const initVerifyCenter = (options: VerifyOptions) => {
  return new VerifyCenter(options);
};

window.captchaFailEvents = [];

/**
 * 由于web端采用的前端热更新机制，在业务方initCaptchaSDK初始化是异步的，所以用户在调用renderCaptcha的时候，有可能renderCaptcha还没挂载到window上而报错。所以在执行js SDK时候会预设置一个占位函数
 * sec_sdk_build/captcha
 * window.renderCaptcha = function(options){
 *   window.renderCaptcha.trigger = function(renderCaptcha){
 *    renderCaptcha(options);
 *   }
 * };
 * 参见包 sec_sdk_build/captcha.js
 */
if (window.renderCaptcha && typeof window.renderCaptcha.trigger === 'function') {
  window.renderCaptcha.trigger(renderCaptcha);
}

window.renderCaptcha = renderCaptcha; // 兼容历史版本
window.closeCaptcha = closeCaptcha; // 兼容历史版本
window.getCaptchaWebId = injectWebId; // 兼容历史版本

window.verifySDK = {
  renderCaptcha,
  closeCaptcha,
  getCaptchaWebId,
  initVerifyOptions,
  renderSecondVerifyWeb,
  renderSecondVerifyH5,
  autoRender,
  SMS,
  initVerifyCenter,
};
if (typeof window.mountCaptchaCallback === 'function') {
  window.mountCaptchaCallback();
}

export { SMS, initVerifyCenter };
